export enum AuthenticationMode {
  TAN = 'tan',
  PASSWORD = 'password',
  NO_CHECK = 'no-check', // XXX: used internally by SSO
}
